const loadingBoxStyle = {
  marginTop: 8,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: 2,
};

export { loadingBoxStyle };
